import antdTranslations from "antd/lib/locale-provider/ca_ES";

export default {
   antd: antdTranslations,
   locale: "sp"
};
